import React from "react";
import Grid from "@mui/material/Grid2";
import { LocalShippingOutlined } from "@mui/icons-material";
import TwitterIcon from "@mui/icons-material/X";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import InstagramIcon from "@mui/icons-material/Instagram";
import { Button } from "@mui/material";
import { Box } from "@mui/material";
import { Typography } from "@mui/material";
import { Link } from "@mui/material";
import { keyLang } from "../../utils/helpers";
import { useSelector } from "react-redux";
import Translation from "../../utils/Translation";
import { memo } from "react";

function TopBar({ handleLanguage }) {
  const { language } = useSelector((state) => state.global);

  return (
    <Grid
      sx={{
        backgroundColor: 'background.paper',
        paddingLeft: "2%",
        paddingRight: "2%",
        paddingTop: 1.5,
        paddingBottom: 1.5,
        borderBottom: 1,
        borderColor: 'divider',
      }}
      container
      alignItems="center"
    >
      <Grid size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <LocalShippingOutlined color="primary" sx={{ fontSize: 34 }} />
          <Typography component="div" lineHeight={1.3}>
            <Typography
              component="span"
              sx={{ display: "block", fontWeight: 700, fontSize: "1rem", color: "text.primary" }}
            >
              <Translation data="layout.parcel_delivery" />
            </Typography>
            <Typography
              component="span"
              sx={{ display: "block", fontSize: ".75rem", color: "text.secondary" }}
            >
              <Translation data="layout.with_deliverit" />
            </Typography>
          </Typography>
        </Box>
      </Grid>

      <Grid alignContent="center" size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
        <Box
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          flexWrap="wrap"
          gap={2}
          sx={{
            "@media (max-width: 900px)": {
              justifyContent: "center",
              marginTop: 1.5,
            },
          }}
        >
          <Box display="inline-flex" alignItems="center">
            <Button
              className={
                language === keyLang[0]
                  ? "lang-active language-english"
                  : "lang-inactive language-english"
              }
              disabled={language === keyLang[0]}
              onClick={(event) => handleLanguage(event, 0)}
              sx={{
                minWidth: "auto",
                color: language === keyLang[0] ? "primary.main" : "text.secondary",
                "&.Mui-disabled": { color: "primary.main" },
              }}
            >
              English
            </Button>
            <Typography component="span" sx={{ color: "text.secondary" }}>
              /
            </Typography>
            <Button
              className={
                language === keyLang[1]
                  ? "lang-active language-arabic"
                  : "lang-inactive language-arabic"
              }
              disabled={language === keyLang[1]}
              onClick={(event) => handleLanguage(event, 1)}
              sx={{
                minWidth: "auto",
                color: language === keyLang[1] ? "secondary.main" : "text.secondary",
                "&.Mui-disabled": { color: "secondary.main" },
              }}
            >
              العربية
            </Button>
          </Box>

          <Box
            display="flex"
            alignItems="center"
            gap={1}
            sx={{
              "& a": {
                display: "inline-flex",
                color: "text.secondary",
                border: 1,
                borderColor: "divider",
                borderRadius: "50%",
                padding: "6px",
                transition: "color .2s ease, border-color .2s ease",
                "&:hover": { color: "primary.main", borderColor: "primary.main" },
              },
            }}
          >
            <Link href="https://www.instagram.com/deliverit_uae" target="_blank">
              <InstagramIcon fontSize="small" />
            </Link>
            <Link href="https://www.facebook.com/DeliveritApp.AE" target="_blank">
              <FacebookOutlinedIcon fontSize="small" />
            </Link>
            <Link href="https://twitter.com/Deliverit_UAE" target="_blank">
              <TwitterIcon fontSize="small" />
            </Link>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
}

export default memo(TopBar);
